import { EDITOR_MODE } from "@pathwright/blocks-engine"
import {
  blocksFontCSS,
  sansSerifStyles
} from "@pathwright/blocks/src/ui/typography"
import styled from "styled-components"

export const ListContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  position: relative;

  .SubText--edit span {
    color: rgba(150, 150, 150, 0.3);
  }

  .SubText--view {
    margin-top: 10px !important;
  }
`

export const CompletedTasks = styled.div`
  margin-top: 0.7rem;
  ${(p) => p.mode === EDITOR_MODE.EDIT && "color: rgba(150, 150, 150, 0.6);"}
  ${sansSerifStyles({ size: 16 })}
`

export const TaskItemWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 0;
  ${blocksFontCSS()}

  &:last-of-type {
    margin-bottom: 10px;
  }
  /* border-bottom: 1px solid #ccc; */
  /* margin: 5px 0px; */

  .Pathicon {
    display: block;
    font-style: normal;
  }

  p {
    padding: 5px 10px 2px 10px !important;
  }
  .ql-blank:before {
    padding: 5px 10px 0px 10px !important;
  }

  .Checkbox {
    padding: 7px 0;
    margin-right: 15px;
    align-items: center;

    & > span:last-of-type {
      width: 100%;
    }
  }

  input[type="checkbox"] {
    // visibility: hidden; /* <-- hide the default checkbox, the rest is to hide and allow tabbing, which display:none prevents */
    display: block;
    height: 19px;
    width: 19px;
    position: absolute;
    // overflow: hidden;
  }

  .checkbox_label {
    background-color: whitesmoke;
    display: inline-block;
    margin-left: 5px;
    width: 19px;
    height: 19px;
    visibility: visible;
    border: 1px solid #cecece;
    border-radius: 4px;
    color: #cecece;
    position: relative;
    margin: 0px;
  }

  [type="checkbox"]:checked + .checkbox_label:before {
    content: "\\e61c";
    font-family: pathicons;
    position: absolute;
    top: -4px;
    left: 0px;
  }

  @media screen and (max-width: 768px) {
    padding: 10px 0;
  }

  @keyframes strike {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  ${(p) =>
    p.completed &&
    `
      .BlockText p,
      .ContentText {
        position: relative;
        transition: color 0.2s;

        &:after {
          ${
            /*content: ' ';
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          height: 1px;
          background: gray;
          animation-name: strike;
          animation-duration: 0.3s;
          animation-timing-function: linear;
          animation-iteration-count: 1;
          animation-fill-mode: forwards; */ ""
          }
        }
      }
    `}
  .BlockText {
    p {
      margin: 0;
      line-height: 1.3;
      ${sansSerifStyles({ size: 18 })}
    }
  }

  ${(p) =>
    p.blockStyles
      ? `
    .IconButton.EditButton i.Pathicon,
    .quill-editor,
    .quill-editor p {
      color: ${p.blockStyles.styleAttributes.color} !important;
    }
  `
      : ""}
`

export const TasklistTitle = styled.h5`
  width: 100%;
  margin: 0;
  ${sansSerifStyles({ size: 26 })}
  font-weight: 700;
  font-style: normal;
  color: #2a2e33;
  line-height: 32px; /* styles to apply quill editor content */
  & > p,
  .ql-editor,
  .ql-editor p,
  .SubText,
  .SubText p {
    margin: 0;
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    line-height: inherit;
  }
`
